import {useEffect} from "react";
import CryptoJS from "crypto-js";

/**
 * makeshop intro page
 * https://www.bizting.co.kr/hosting/makeshop/intro
 * */
const HostingMIntro = () => {
    useEffect(() => {
        const state = {
            hostType: 'M',
        };

        let encryptedState = encodeURIComponent(CryptoJS.AES.encrypt(JSON.stringify(state), process.env.REACT_APP_AES_ENCRYPT_KEY).toString());

        let url = `${process.env.REACT_APP_MAKESHOP_INTRO_REDIRECT_URI}`;
        url += `?state=${encryptedState}`;

        window.location.href = url;
    });
};

export default HostingMIntro;
